export enum ClaraConversationOrigin {
  CE_APP = 'ce_app',
  SLACK = 'slack',
  FINANCIAL_ADVISOR = 'financial_advisor',
  FINANCIAL_ADVISOR_PRO = 'financial_advisor_pro',
  ADVISOR_OPPORTUNITIES = 'advisor_opportunities',
  PLANNER = 'planner'
}
